import { render, staticRenderFns } from "./AcceptedProjectRequestComponent.vue?vue&type=template&id=ddb2b004&"
import script from "./AcceptedProjectRequestComponent.vue?vue&type=script&lang=ts&"
export * from "./AcceptedProjectRequestComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports